import React, { useEffect, useState, useRef } from "react";// AssessApp.js 임
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './AssessApp.scss';
import HongButton from "../comm/HongButton";
import { useNavigate, useLocation } from "react-router-dom";
import Assess_all_marking from './Assess_all_marking';
// import Assess_all_marking_link from './__Assess_all_marking_link';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveLink, setIsLoggedIn, setUserInfo, setUserName, setUserKind, 
          setSelectedStCode, setSelectedUserInfo, setSelectedTestCode } from "../reduxToolkit/reduxIgong";


const AssessApp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const token = queryParams.get('token');
    // const [isToken, setIsToken] = useState(false);


    // useEffect(() => {
    //     if (token) {
    //         fncDecodeToken(token);
    //         setIsToken(true);
    //     }
    // }, [token]);


    function fncDecodeToken(token) {
          fnc.sendAxios('/igongAssess_linkRoutes/tokenDecode', {token }, (res) => {          
            if (res) {
                if (res.success) {
                    const stCode = res.decoded.stCode;
                    const userKind = res.decoded.userKind;
                    const testCode = res.decoded.testCode;

                    // alert(testCode);
                    fncTokenLogin(stCode, userKind, testCode);
                  } else {
                    alert('유효하지 않은 토큰입니다.');
                    fncGotoHome();
                  }
              
            } else {
                alert('토근이 없습니다2.');
                fncGotoHome();
            }
        });
    }

    //-------------------토큰 로그인
      function fncTokenLogin(stCode, userKind, testCode) {
        fnc.sendAxios('/igongAssess_linkRoutes/select/tokenLogin', { stCode, userKind }, (res) => {
          if (res.length) {
            const userKind = res[0].userKind;
            const userInfo = res[0];
            dispatch(setUserInfo(res[0]));
            dispatch(setIsLoggedIn(true));
            dispatch(setUserName(res[0].userName));
            dispatch(setUserKind(userKind));

            dispatch(setSelectedTestCode(testCode));
            dispatch(setSelectedUserInfo(userInfo));
    
          } else {
            alert('토큰 정보가 올바르지 않습니다.');
            fncGotoHome();
          }
        });
      }
    

      function fncGotoHome() {
        navigate('/loginWhere');
      }
    //=============================================
    return (
        // <S.Section>
            <div className="AssessApp">

              <Assess_all_marking />
        
              {/* { 
                isToken
                ? <Assess_all_marking_link isToken={isToken} />
                : <Assess_all_marking isToken={isToken} />
              } */}
                

        
            </div>
        // </S.Section>
    );
};

export default AssessApp;
